module.exports = "/images/Quest Room.svg?529d6fbb4706a8ec32ed4df6ac739ddf";